export default __webpack_public_path__ + "static/media/picas.68b8bd15.PNG";